export default __webpack_public_path__ + "/dist/images/logo8.9d84b410c2cb64a6026978782d8fbd64.png";